<template>
  <PageShell class="page-shell-wrapper--old-versions" locale="id" :page-title="pageTitle">
    <OldVersionsContent />
  </PageShell>
</template>

<script>
import PageShell from '@/components/layout/PageShell.vue';
import OldVersionsContent from './OldVersionsContent.vue';

export default {
  name: 'OldVersionsPage',
  components: { PageShell, OldVersionsContent },
  computed: {
    pageTitle() {
      return this.$route.meta.pageTitle || '';
    },
  },
};
</script>
